import { Subtitle } from '@vrzl/ui';
import { ExternalLink } from 'lucide-react';

import { buildRxMissionUrl } from '../lib/rxMission';

type RxMissionLinkProps = {
  externalId: string | null | undefined;
  className?: string;
};

/**
 * Toont het Zaaknummer (externalId) als subtiele inline hyperlink naar de
 * bijhorende zaak in Rx.Mission. Semantische <a> (geen window.open) zodat
 * middenklik / "open in nieuw tabblad" gewoon werken.
 */
export function RxMissionLink({ externalId, className }: RxMissionLinkProps) {
  if (!externalId) return null;

  return (
    <Subtitle className={className}>
      <a
        href={buildRxMissionUrl(`?zaaknummer=${externalId}`)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Open ${externalId} in Rx.Mission`}
        className="inline-flex items-center gap-1 hover:underline"
      >
        {externalId}
        <ExternalLink className="size-3.5" aria-hidden="true" />
      </a>
    </Subtitle>
  );
}
